<template>
  <div class="page-content--body">
    <div class="page-content--body-right error-page">
      <div class="error-page--title">404</div>
      <div class="error-page--subtitle">Страница не найдена</div>
      <div class="error-page--text">
        Страница, на которую вы пытаетесь попасть, не существует или была удалена.<br>
        Перейдите на <router-link to="/dashboard">главную страницу</router-link>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    mounted() {
      this.$store.dispatch('SetTitle', 'Ошибка');
    },
  };
</script>

<style lang="scss">
  .error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-around;
    height: calc(100vh - 200px);
    @media (max-width: 1024px) {
      height: calc(100vh - 230px);
    }
    &--title {
      font-size: 20vw;
      font-weight: bold;
      line-height: 1;
      @media (max-width: 767px) {
        font-size: 20vw!important;
        margin-bottom: 30px;
      }
    }
    &--subtitle {
      font-size: 3vw;
      line-height: 1;
      margin-bottom: 20px;
      @media (max-width: 767px) {
        font-size: 20px!important;
      }
    }
  }
</style>
